import {
  CLEAN_FAILED_TRANSACTIONS_LIST_IPB,
  CLEAN_FAILED_TRANSACTIONS_LIST_IPB_ERROR,
} from '_models/redux/types';

export const cleanFailedTransactionsListIpbAction = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_FAILED_TRANSACTIONS_LIST_IPB,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_FAILED_TRANSACTIONS_LIST_IPB_ERROR,
    });
  }
};
